import { useTranslation } from 'react-i18next';
import { displayLoanType } from '../../../Loan';
import { LoanFormSideOverPageProps } from './types';
import { ElementsButton, SideOverFooter, SideOverHeaderNew, SideOverHeading, StandardLoanForm } from '../../components';
import { useWindowSize } from 'react-use';
import { MDTailwindMinPixelBreakpointWidth } from '../../../util';

export function LoanFormSideOverPage({
  exit,
  firmID,
  loanType,
  clientID,
  isLoading,
  householdID,
  useLoanFormReturn,
  sideOverHeaderChildren,
  loanFormVisibilityOptions,
}: LoanFormSideOverPageProps) {
  const { t: tLoan } = useTranslation('loan');
  const { t: tCommon } = useTranslation('common');
  const isLessThanMD = useWindowSize().width < MDTailwindMinPixelBreakpointWidth;

  return (
    <>
      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')}>
        {sideOverHeaderChildren}
      </SideOverHeaderNew>
      <div className="md:px-10 px-6">
        <SideOverHeading heading={displayLoanType(loanType, tLoan)} />
        {useLoanFormReturn.formReady && (
          <StandardLoanForm
            firmID={firmID}
            loanType={loanType}
            clientID={clientID}
            householdID={householdID}
            className="mb-28 md:mb-36"
            useLoanFormReturn={useLoanFormReturn}
            visibilityOptions={loanFormVisibilityOptions}
          >
            <SideOverFooter>
              <ElementsButton
                icon="check"
                iconPosition="left"
                isLoading={isLoading}
                label={tCommon('save')}
                size={isLessThanMD ? 'small' : 'large'}
              />
            </SideOverFooter>
          </StandardLoanForm>
        )}
      </div>
    </>
  );
}
